import { EnumPriceOrigin } from './Generated';

export function getPriceOriginLabel(priceOrigin: EnumPriceOrigin) {
    switch (priceOrigin) {
        case EnumPriceOrigin.None:
            return 'Kein Preis';
        case EnumPriceOrigin.Manual:
            return 'Handeingabe';
        case EnumPriceOrigin.PriceList:
            return 'Preisliste';
        case EnumPriceOrigin.Fixed:
            return 'Leistung';
    }
}
